import { render, staticRenderFns } from "./GruposEmpresaDialog.vue?vue&type=template&id=9a67b4ee&scoped=true&lang=pug"
import script from "./GruposEmpresaDialog.vue?vue&type=script&lang=js"
export * from "./GruposEmpresaDialog.vue?vue&type=script&lang=js"
import style0 from "./GruposEmpresaDialog.vue?vue&type=style&index=0&id=9a67b4ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a67b4ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VDataTable,VIcon,VProgressLinear,VSpacer,VTextField,VTooltip})
